import { Field, FieldProps } from "formik";

import {
  FormControlLabel,
  FormControlLabelProps,
  Checkbox,
  CheckboxProps
} from "@material-ui/core";

export default function FormikCheckboxField({
  name,
  label,
  labelProps,
  checkboxProps
}: CheckboxProps & {
  name: string;
  label: string;
  labelProps?: FormControlLabelProps;
  checkboxProps?: CheckboxProps;
}): JSX.Element {
  return (
    <FormControlLabel
      control={
        <Field name={name}>
          {({ meta, form }: FieldProps) => (
            <Checkbox
              color={
                meta.error ? "secondary" : (checkboxProps?.color ?? "primary")
              }
              checked={!!meta.value}
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
                form.setFieldValue(name, evt.target.checked)
              }
              {...checkboxProps}
            />
          )}
        </Field>
      }
      label={label}
      {...labelProps}
    />
  );
}
